import { isVNode as _isVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
/**
 * @author xiezhixiong
 * @fileoverview 冠军赛64进16对战图
 */
import { defineComponent, ref, onMounted, onBeforeUnmount, watch } from "vue";
import useRespondTo from "@/hooks/common/respond-to";
import ZoneHeader from "./components/ZoneHeader";
import MiniPagination from "./components/MiniPagination";
import WarSchedule from "../../common/war-schedule";
import { battleTeamNum } from "./utils";
function _isSlot(s) {
  return typeof s === 'function' || Object.prototype.toString.call(s) === '[object Object]' && !_isVNode(s);
}
export default defineComponent({
  name: "BattleMap64",
  props: {
    zone1Teams: {
      type: Array,
      default() {
        return [];
      }
    },
    zone2Teams: {
      type: Array,
      default() {
        return [];
      }
    },
    curPage: {
      type: Number
    },
    battleList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  emits: ["pagination-change", "select"],
  setup(props, {
    emit
  }) {
    const raceScale = ref(0);
    const swiperRef = ref(null);
    const {
      isMobile
    } = useRespondTo();
    const resizeListener = () => {
      const innerWidth = window.innerWidth;
      // 赛事图原本大小 383，在 375 宽度的屏幕下，显示为 207 ，
      // 求当前屏幕宽度的缩放比
      raceScale.value = 207 * innerWidth / 375 / 383;
    };
    resizeListener();
    const attachResizeListener = () => {
      window.addEventListener("resize", resizeListener);
    };
    const detachResizeListener = () => {
      window.removeEventListener("resize", resizeListener);
    };
    onMounted(() => {
      attachResizeListener();
    });
    onBeforeUnmount(() => {
      detachResizeListener();
    });

    // 重置 swiper 到 0
    watch(() => props.battleList, newVal => {
      if (!newVal.length) {
        var _swiperRef$value;
        (_swiperRef$value = swiperRef.value) === null || _swiperRef$value === void 0 ? void 0 : _swiperRef$value.swipeTo(0);
      }
    });
    const handlePaginationChange = page => {
      emit("pagination-change", page);
    };
    const handleMiniPaginationChange = page => {
      var _swiperRef$value2;
      handlePaginationChange(page);
      (_swiperRef$value2 = swiperRef.value) === null || _swiperRef$value2 === void 0 ? void 0 : _swiperRef$value2.swipeTo(page - 1);
    };
    const handleSelect = record => {
      if (!record) {
        return;
      }
      emit("select", record);
    };
    const groupMap = {
      1: ["甲区", "乙区"],
      2: ["丙区", "丁区"]
    };
    const groupMap_m = ["甲区", "乙区", "丙区", "丁区"];
    const swipeItems_pc = [1, 2];
    const swipeItems_mb = [1, 2, 3, 4];
    return () => {
      let _slot2;
      const swipeData_pc = [[props.battleList[0], props.battleList[1]], [props.battleList[2], props.battleList[3]]];
      if (isMobile.value) {
        let _slot;
        return _createVNode("div", {
          "class": "battle-map-m"
        }, [_createVNode("div", {
          "class": "battle-map-header"
        }, [_createVNode("div", {
          "class": "battle-map-header-item"
        }, [_createVNode(ZoneHeader, {
          "title": groupMap_m[props.curPage - 1]
        }, null)])]), _createVNode("div", {
          "class": "battle-map-race battle-map-m-race"
        }, [_createVNode(_resolveComponent("van-swipe"), {
          "class": "battle-map-m-race-swiper",
          "showIndicators": false,
          "loop": false,
          "onChange": i => handlePaginationChange(i + 1),
          "ref": swiperRef
        }, _isSlot(_slot = swipeItems_mb.map((item, index) => _createVNode(_resolveComponent("van-swipe-item"), {
          "key": item
        }, {
          default: () => [_createVNode("div", {
            "class": "battle-map-list battle-map-m-list",
            "style": {
              transform: `scale(${raceScale.value})`
            }
          }, [_createVNode("div", {
            "class": "battle-map-list-item"
          }, [_createVNode(WarSchedule, {
            "teams": props.battleList[index],
            "teamNum": battleTeamNum(props.battleList[index]),
            "gridHeight": 23,
            "gridWidth": 130,
            "height": "700px",
            "offset": {
              top: 20,
              left: 30
            },
            "stroke": false,
            "onSelect": handleSelect
          }, null)])]), _createVNode("div", {
            "class": "battle-map-promotion battle-map-m-promotion"
          }, null)]
        }))) ? _slot : {
          default: () => [_slot]
        })]), _createVNode("div", {
          "class": "battle-map-pagination battle-map-m-pagination"
        }, [_createVNode(MiniPagination, {
          "total": 40,
          "pageSize": 10,
          "onChange": handleMiniPaginationChange,
          "current": props.curPage
        }, null)])]);
      }
      return _createVNode("div", {
        "class": "battle-map"
      }, [_createVNode("div", {
        "class": "battle-map-header"
      }, [_createVNode("div", {
        "class": "battle-map-header-item"
      }, [_createVNode(ZoneHeader, {
        "title": groupMap[props.curPage][0]
      }, null)]), _createVNode("div", {
        "class": "battle-map-header-item"
      }, [_createVNode(ZoneHeader, {
        "title": groupMap[props.curPage][1]
      }, null)])]), _createVNode("div", {
        "class": "battle-map-race"
      }, [_createVNode(_resolveComponent("van-swipe"), {
        "class": "battle-map-race-swiper",
        "showIndicators": false,
        "loop": false,
        "onChange": i => handlePaginationChange(i + 1),
        "ref": swiperRef
      }, _isSlot(_slot2 = swipeItems_pc.map((item, index) => _createVNode(_resolveComponent("van-swipe-item"), {
        "key": item
      }, {
        default: () => [_createVNode("div", {
          "class": "battle-map-list"
        }, [_createVNode("div", {
          "class": "battle-map-list-item"
        }, [_createVNode(WarSchedule, {
          "teams": swipeData_pc[index][0],
          "teamNum": battleTeamNum(swipeData_pc[index][0]),
          "gridHeight": 23,
          "height": "700px",
          "offset": {
            top: 20,
            left: 40
          },
          "stroke": false,
          "onSelect": handleSelect
        }, null)]), _createVNode("div", {
          "class": "battle-map-list-item"
        }, [_createVNode(WarSchedule, {
          "teams": swipeData_pc[index][1],
          "teamNum": battleTeamNum(swipeData_pc[index][1]),
          "gridHeight": 23,
          "height": "700px",
          "offset": {
            top: 20,
            left: -180
          },
          "onSelect": handleSelect,
          "reverse": true
        }, null)])]), _createVNode("div", {
          "class": "battle-map-promotion"
        }, null)]
      }))) ? _slot2 : {
        default: () => [_slot2]
      })]), _createVNode("div", {
        "class": "battle-map-pagination"
      }, [_createVNode(MiniPagination, {
        "total": 20,
        "pageSize": 10,
        "onChange": handleMiniPaginationChange,
        "current": props.curPage
      }, null)])]);
    };
  }
});